require("./gauge/GaugeSeries");

require("./gauge/GaugeView");